import { Component } from '@angular/core';
import { LoginServicesService } from '../../services/login-services.service';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';

@Component({
    selector: 'app-error-page',
    imports: [ButtonModule],
    templateUrl: './error-page.component.html',
    styleUrl: './error-page.component.scss'
})
export class ErrorPageComponent {

  constructor(private service:LoginServicesService,private router:Router){

  }

  checkStatus(){
    this.service.checkStatus().subscribe({
        next:(resp:any)=>{
        localStorage.clear();
        this.router.navigate(['login']);
      },
      error:() =>{
        localStorage.clear();
        this.router.navigate(['login']);
      }
    })
  }


}
